import { render, staticRenderFns } from "./UserRegistrationInputs.vue?vue&type=template&id=15237559"
import script from "./UserRegistrationInputs.vue?vue&type=script&lang=js"
export * from "./UserRegistrationInputs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports